<app-tabs
  [items]="tabs"
  [(selectedTabIndex)]="tabIndex"
  [appBlockModalDrag]="!(isMobileModeObservable | async)"
></app-tabs>

<div class="tab" [hidden]="tabIndex !== 0">
  <app-occurrence-register
    [mapView]="mapView"
    [mainMapImageLayer]="mainMapImageLayer"
    [groupLayer]="occurrenceRegisterGroupLayer"
    *appDeferRendering="tabIndex === 0"
  ></app-occurrence-register>
</div>

<div class="tab" [hidden]="tabIndex !== 1">
  <app-search-occurrence
    [mapView]="mapView"
    [mainMapImageLayer]="mainMapImageLayer"
    [groupLayer]="occurrenceSearchGroupLayer"
    *appDeferRendering="tabIndex === 1"
  ></app-search-occurrence>
</div>
